<script>
    import {formatMoney} from 'accounting';
    import {optionalTaxes, assessedValue, nonAssessedValueTaxAmounts} from './stores.js';
    import {calculateAmount, isNotAssessedValueTax, round} from './calculator.js';
    export let mainRates;

    $: amountReducer = (obj) => Object.getOwnPropertyNames(obj).reduce((p,c) =>
        p + calculateAmount(obj[c],$assessedValue,$nonAssessedValueTaxAmounts[c]),0)
    $: rateReducer = (obj) => Object.values(obj).reduce((p,c) =>
        p + (isNotAssessedValueTax(c)?0:c), 0);

    $: totalAmount = amountReducer(mainRates) + amountReducer($optionalTaxes);
    $: totalRate = round(rateReducer(mainRates) + rateReducer($optionalTaxes), 4);
</script>
<tr>
    <th scope="row">Total</th>
    <td class="number-column">{totalRate}</td>
    <td class="number-column">{formatMoney(totalAmount)}</td>
</tr>